export const neighborhoodSearch = {
  hotSearch:"大家都在搜索",
  inputName:"输入方案名称",
  planCount:`共 {count} 个户型`,
  neighborhoodCount:`共 {count} 个楼盘`,
  relevant:"相关楼盘",
  empty: '暂无相关楼盘和户型'
};
